import { Search } from '@domain-group/suit-theme'

import useGeoStates from '@hooks/useGeoStates'
import useSelector from '@hooks/useSelector'

import searchEndpoint from '@functions/search'

import type { EntitiesState } from '@redux/entities'

import type { GeoSuburbModel } from '@models/types'

const mapSuburbResults = (geoSuburbs: GeoSuburbModel[], geoStates: EntitiesState['geoStates']) => ({
  groups: [
    {
      key: 'geoSuburbs',
      title: 'SUBURBS',
      items: geoSuburbs.map(suburb => ({
        id: suburb.id,
        key: suburb.id,
        post_code: suburb.post_code,
        secondaryText: `${suburb.post_code} ${geoStates[suburb.geo_state_id]?.code || ''}`,
        geo_state_id: suburb.geo_state_id,
        text: suburb.title,
        title: suburb.title,
      })),
    },
  ],
})

type SuburbSearchProps = {
  callbacks: {
    onChange: (value: string) => void,
    selectItem: (geoSuburb: GeoSuburbModel) => void,
  },
  requestOptions?: {
    geo_country_id?: number,
  },
  value: string,
}

const SuburbSearch = (props: SuburbSearchProps) => {
  const {
    callbacks, requestOptions = {}, value,
  } = props

  const { geo_country_id } = requestOptions

  useGeoStates({ filters: { geo_country_id }, performHttpRequests: true })

  const { geoStates } = useSelector(reduxState => reduxState.entities)

  return (
    <Search
      callbacks={{
        ...callbacks,
        // @ts-expect-error TS2345
        mapResults: data => mapSuburbResults(data, geoStates),
        // @ts-expect-error TS2322
        search: searchEndpoint,
      }}
      debounceInterval={300}
      endpoint="geo_suburbs.json"
      forwardProps={{
        closeOnSelect: true,
        filterItems: false,
        setStringOnSelect: true,
        showOnFocus: true,
      }}
      // @ts-expect-error TS2322
      requestOptions={{ geo_country_id }}
      value={value}
    />
  )
}

export default SuburbSearch
